"use client";

import CasesGrid from "@/components/Cases/CasesGrid/CasesGrid";
import { Footer } from "@/components/layout/Footer/Footer";
import React from "react";
import { CasesHero } from "@/components/Cases/CasesHero/CasesHero";
import CasesDucks from "@/components/Cases/CasesDucks/CasesDucks";
import { AnimationStateKeys, useDuck } from "@/provider/DuckContext";

export default function SectionProjects({ data }) {
  const { handleDuckAnimation } = useDuck();

  const handleCaseHover = (side) => {
    let randomizer = Math.random();

    if (side === "right") {
      handleDuckAnimation(
        randomizer < 0.5 ? AnimationStateKeys.SIDE : AnimationStateKeys.YES
      );
    }

    if (side === "left") {
      handleDuckAnimation(
        randomizer < 0.5 ? AnimationStateKeys.JUMP : AnimationStateKeys.YES
      );
    }
  };

  return (
    <>
      <section>
        <CasesDucks />
        <div
          className="duck_scroll_container"
          style={{ width: "100%", position: "relative" }}
        >
          <div style={{ position: "relative" }}>
            <CasesHero messages={data.projectsHero} />
            <div
              style={{ marginTop: "200px", marginBottom: "200px" }}
              className="container"
            >
              <CasesGrid
                projects={data.projectsList}
                handleCaseHover={handleCaseHover}
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
